import { Badge, Button, Col, Divider, Empty, Collapse, Pagination, Row, Select, Spin } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { BiSend } from "react-icons/bi";
import { useSelector } from 'react-redux';
import { appConfig } from '../../../Environments/config';
import { joinRoom, onLeaveRoom, sendMessageSocket } from '../../../Libraries/socket';
import { setCurrentRoomInRedux, setMessages, setPageLoader, setRooms } from '../../../Redux/Features';
import { utility } from '../../../Utility';
import Messages from './components/messages';
import socketIoClient from "socket.io-client"
import { Message } from '../../../Utility/Services';
import Loader from '../../Loader/Loader';
import { catchAsyncErrors } from '../../../API/Handlers';
import ChatTab from './components/ChatTab';
import { postRequest } from '../../../API/api.methods';
import { apiRoutes } from '../../../API/api.routes';
import { BsThreeDotsVertical } from "react-icons/bs";
import ReactCountryFlag from 'react-country-flag';
import { GiCancel } from "react-icons/gi";
import { LoadingOutlined } from '@ant-design/icons';
import { differenceInDays, formatDistanceToNow } from 'date-fns';
const Chat = () => {

    const [selectedTab, setSelectedTab] = useState("active")
    const [message, setMessage] = useState(null)
    const [currentRoom, setCurrentRoom] = useState(null)
    const [currentRoomData, setCurrentRoomData] = useState(null)
    const { messages, rooms } = useSelector(state => state?.chat)
    const messagesEndRef = useRef(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [countries, setCountries] = useState([]);
    const [toggleDetails, setToggleDetails] = useState(false)
    const socketRef = useRef(null);
    const [isAdminActive, setIsAdminActive] = useState(false); // Default to false
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 15,
        total: 0
    })

    const onSelectTab = (key) => {
        setSelectedTab(key)
    }
    const { Option } = Select;
    const onSelectCountry = (country) => {
        setSelectedCountry(country || null);
        setPagination((prev) => ({ ...prev, page: 1 }));
    };


    useEffect(() => {
        socketRef.current = socketIoClient(appConfig.socketURL);
        socketRef.current.on('admin-event[delay]', handleDelayEvent);
        socketRef.current.on('admin-listner[notification:receive]', handleNotificationEvent);

        return () => {
            socketRef.current.off('admin-event[delay]', handleDelayEvent);
            socketRef.current.off('admin-listner[notification:receive]', handleNotificationEvent);
            socketRef.current.disconnect();
        };
    }, []);
    const handleDelayEvent = (response) => {
        if (response?.leave_room) {
            let roomID = currentRoom;
            onLeaveRoom(currentRoom, setCurrentRoom);
            Message.info('Due to inactivity, bot has been connected to the chat ID: ' + roomID);
        }
    };

    const handleNotificationEvent = (response) => {
        Message.success(`${response?.room_id} message: ${response?.message}`);
        getRooms();
    };
    const sendMessageSocketWithLastResponse = (message, setMessage, room_id, rooms) => {
        sendMessageSocket(message, setMessage, room_id);
        const updatedRooms = rooms.map(room =>
            room.room_id === room_id ? { ...room, last_response_time: new Date().toISOString() } : room
        );
        utility.dispatch(setRooms(updatedRooms.sort((a, b) => new Date(b.last_response_time) - new Date(a.last_response_time))));
    };
    const getRooms = catchAsyncErrors(async (showLoader = true, append = false) => {
        if (showLoader) {
            utility.dispatch(setPageLoader({ page: "getRooms", flag: true }));
        }

        let url = `${appConfig.socketURL}/api/rooms?page=${pagination?.page}&limit=${pagination?.limit}&tab=${selectedTab}`;

        if (selectedCountry) {
            url += `&country=${selectedCountry}`;
        }

        let res = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });

        if (showLoader) {
            utility.dispatch(setPageLoader({ page: "getRooms", flag: false }));
        }

        let response = await res.json();
        setPagination((prev) => ({ ...prev, total: response?.total_count }));

        let data = response?.rooms
        if (pagination?.page > 1)
            return utility.dispatch(setRooms([...rooms, ...data]));
        utility.dispatch(setRooms(data));


    });

    const onClickConversation = catchAsyncErrors(async (id) => {
        if (currentRoom === id) { return }
        if (currentRoom) onLeaveRoom(currentRoom, setCurrentRoom)
        utility.dispatch(setPageLoader({ page: "onClickConversation", flag: true }))
        let res = await fetch(`${appConfig.socketURL}/api/rooms/` + id, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
        utility.dispatch(setPageLoader({ page: "onClickConversation", flag: false }))
        let response = await res.json()
        joinRoom(id)
        setCurrentRoom(id)
        utility.dispatch(setCurrentRoomInRedux(id))
        utility?.dispatch(setMessages(response?.room?.messages))
        console.log(response?.room?.messages, 'asdasdasd')
    })
    useEffect(() => {
        getRooms(true, pagination.page > 1);
    }, [pagination.page, selectedTab, selectedCountry]);

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await fetch(`${appConfig.socketURL}/api/countries`);
                const data = await response.json();
                setCountries(data || []);
            } catch (error) {
                console.error("Error fetching countries:", error);
            }
        };
        fetchCountries();
    }, []);

    useEffect(() => {
        setPagination((prev) => (prev.page !== 1 ? { ...prev, page: 1 } : prev));
        utility.dispatch(setRooms([]));
    }, [selectedTab, selectedCountry]);

    useEffect(() => {
        getRooms(true);
    }, [pagination?.total, selectedTab, selectedCountry, pagination?.page]);

    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages]);

    const handleLeaveRoomImmediate = catchAsyncErrors(async () => {
        const response = await postRequest({
            endPoint: apiRoutes?.chat?.leaveConversation,
            body: { room_id: currentRoom }
        })
        if (response?.leave_room) {
            setCurrentRoom(null)
            setToggleDetails(false)
            utility.dispatch(setCurrentRoomInRedux(null))
        }
    })

    const [isLoading, setIsLoading] = useState(false);

    const loadMoreRooms = async () => {
        if (isLoading || rooms.length >= pagination.total) return; // Prevent multiple calls

        setIsLoading(true); // Lock API call

        try {
            console.log(`Loading page ${pagination.page}`); // Debugging log

            await getRooms(false, true); // Use getRooms function to fetch more rooms

            setPagination((prev) => ({ ...prev, page: prev.page + 1 })); // Increment page
        } catch (error) {
            console.error("Error loading more rooms:", error);
        } finally {
            setIsLoading(false); // Unlock API call
        }
    }


    const handleJoinRoom = catchAsyncErrors(async () => {
        if (isAdminActive) {
            return;
        }

        const response = await postRequest({
            endPoint: apiRoutes?.chat?.join_Room,
            body: { room_id: currentRoom }
        });
        if (response?.joined_room == true) {
            setCurrentRoom(null);
            utility.dispatch(setCurrentRoomInRedux(null));
            setIsAdminActive(true)
            setCurrentRoom(currentRoom);
        } else {
            console.error("Failed to join room");
        }
    });

    useEffect(() => {
        const fetchAdminStatus = async () => {
            if (!currentRoom) return;

            utility.dispatch(setPageLoader({ page: "onClickConversation", flag: true }));

            try {
                const res = await fetch(`${appConfig.socketURL}/api/rooms/${currentRoom}`
                    , {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    });

                const response = await res.json();
                setIsAdminActive(response?.room?.is_admin_active ?? false); // Update state
                utility.dispatch(setMessages(response?.room?.messages));
            } catch (error) {
                console.error("Error fetching admin status:", error);
            } finally {
                utility.dispatch(setPageLoader({ page: "onClickConversation", flag: false }));
            }
        };

        fetchAdminStatus();
    }, [currentRoom]);

    useEffect(() => {
        if (currentRoom) {
            const room = rooms.find(room => room.room_id === currentRoom)
            if (room) {
                setCurrentRoomData(room)
            }
        }
    }, [currentRoom])
    useEffect(() => {
        console.log("Current rooms in state:", rooms);
    }, [rooms]);


    return (
        <div className='p-4 h-full bg-[#EEF5FF]'>

            <div className='grid grid-cols-12 gap-0 h-full'>
                <div className={`${(currentRoom && toggleDetails) ? 'col-span-9' : 'col-span-12'} flex rounded-xl drop-shadow-xl h-full px-3 pt-3 overflow-hidden bg-white`}>
                    <div className='flex flex-1 flex-col'>
                        <Row>
                            <Col md={20}>
                                <SelectSearch countries={countries} onSelectCountry={onSelectCountry} className="" />
                            </Col>
                            <Col md={4}>
                                <ChatTab activeTab={selectedTab} onSelectTab={onSelectTab} />
                            </Col>
                        </Row>
                        <ChatRooms rooms={rooms} onClickConversation={onClickConversation} loadMore={loadMoreRooms} />
                        <div className='mt-1 mb-1'>
                        </div>
                    </div>

                    <div className='flex flex-[2] flex-col h-full px-5 bg-white overflow-hidden'>
                        <MessagesCenter
                            currentRoom={currentRoom} setMessage={setMessage}
                            sendMessageSocketWithLastResponse={sendMessageSocketWithLastResponse}
                            message={message}
                            messagesEndRef={messagesEndRef}
                            rooms={rooms}
                            selectedRoom={currentRoomData}
                            setToggleDetails={setToggleDetails}
                            handleJoinRoom={handleJoinRoom}
                            handleLeaveRoomImmediate={handleLeaveRoomImmediate}
                            isAdminActive={isAdminActive}
                        />

                    </div>

                </div>
                {currentRoom && toggleDetails &&
                    <div className='col-span-3 px-3 flex flex-col gap-2'>
                        <div className='bg-white rounded-xl drop-shadow-md items-center justify-center flex flex-col flex-1 overflow-scroll no-scrollbar'>
                            <h3 className='text-center font-bold text-lg'>User Detail</h3>
                            <InfoItem label={'Email'} value={currentRoomData?.email || currentRoomData?.client_email || "N/A"} />
                            <InfoItem label={'Reference'} value={currentRoomData?.came_from || "liqteq.com"} />
                            <InfoItem label={'IP'} value={currentRoomData?.location?.ip_address || "N/A"} />
                            <InfoItem label={'Current Page'} value={currentRoomData?.last_page_on_website || "N/A"} />
                            <InfoItem label={'Contact Added'} value={currentRoomData.contact_added_ghl
                                ? "Added"
                                : "Not Added"} />
                        </div>
                        <div className='bg-white rounded-xl drop-shadow-md p-3 flex flex-col flex-[2] overflow-scroll no-scrollbar max-h-[calc(100vh-280px)]'>
                            <h3 className='text-center font-bold text-lg'>Sessions</h3>
                            <SessionList sessions={currentRoomData?.sessions || []} />
                        </div>

                    </div>

                }
            </div>

        </div >

    )
}

export const SessionList = ({ sessions }) => {

    const Pages = ({ page, pageIndex }) => {
        return (
            <li key={pageIndex}>
                <div>
                    <Divider />
                    <strong>Page Name:</strong> {page.page_name || "N/A"}
                </div>
                <div>
                    <strong>Entry Time:</strong> {page.entry_time || "N/A"}
                </div>
                <div>
                    <strong>Exit Time:</strong> {page.exit_time || "N/A"}
                </div>
                <div>
                    <strong>Duration:</strong> {page.duration || "N/A"}
                </div>
            </li>)
    }

    const Session = ({ session }) => {
        return (
            <div>
                <div>
                    <strong>Session ID:</strong> {session.session_id || "N/A"}
                </div>
                <div>
                    <strong>Start Time:</strong>{" "}
                    {session.start_time ? new Date(session.start_time).toLocaleTimeString() : "N/A"}
                </div>
                <div>
                    <strong>End Time:</strong>{" "}
                    {session.end_time ? new Date(session.end_time).toLocaleTimeString() : "N/A"}
                </div>
                {session.pages?.length > 0 ? (
                    <ul>
                        {session.pages.map((page, pageIndex) => (
                            <Pages page={page} pageIndex={pageIndex} />
                        ))}
                    </ul>
                ) : (
                    <div>No pages found</div>
                )}
            </div>
        )
    }

    const items = sessions.map((sess, index) => ({ key: sess.session_id, label: 'Session# ' + index + 1, children: <Session session={sess} /> }))

    return <Collapse items={items} bordered={false} defaultActiveKey={['1']} className='bg-white' />
}

export const InfoItem = ({ label, value }) => {
    return (
        <div className='flex w-full items-center justify-center gap-2'>
            <p className='font-semibold text-base'>{label}:</p>
            <p className=''>{value}</p>
        </div>
    )
}

const MessagesCenter = ({ currentRoom, setMessage, sendMessageSocketWithLastResponse, handleLeaveRoomImmediate, handleJoinRoom, isAdminActive, message, messagesEndRef, setToggleDetails, selectedRoom, rooms }) => {
    const pageLoader = useSelector(state => state?.utils?.pageLoader)
    const loading = pageLoader['onClickConversation']

    if (loading) {
        return (
            <div className='flex flex-col gap-2 flex-1 items-center justify-center'>
                <LoadingOutlined className='text-[24px] text-custom-primary-700' spin />
                <p className='text-center text-base'>Loading...</p>
            </div>
        )
    }
    return (
        currentRoom ? (
            <div className=' flex flex-col h-full' >
                <ChatHeader setToggleDetails={setToggleDetails} room={selectedRoom} handleLeaveRoomImmediate={handleLeaveRoomImmediate} handleJoinRoom={handleJoinRoom} isAdminActive={isAdminActive} />
                <div className='flex flex-[6] flex-col overflow-y-auto p-2 no-scrollbar'>
                    <Messages />
                    <div ref={messagesEndRef} />
                </div>
                {isAdminActive && <div className='flex flex-[0.2] items-center gap-1 py-2 px-8 border-t border-slate-200'>
                    <TextArea
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Type a message"
                        autoSize={{ minRows: 1, maxRows: 5 }}
                        className="text-[12px] p-[7px] no-scrollbar w-full"
                        onPressEnter={(event) => {
                            if (!event.shiftKey) {
                                event.preventDefault();
                                sendMessageSocketWithLastResponse(message, setMessage, currentRoom, rooms);
                            }
                        }}
                    />
                    <Button
                        className='text-bold cursor-pointer bg-blue-600 rounded-lg w-[40px] h-[35px] p-0 text-white flex items-center justify-center'
                        disabled={!message}
                        onClick={() => sendMessageSocketWithLastResponse(message, setMessage, currentRoom, rooms)}
                    >
                        <BiSend className='text-[15px]' />
                    </Button>
                </div>}
            </div >
        ) :
            <NoChatSelected />

    )
}

const ChatHeader = ({ setToggleDetails, room, handleJoinRoom, handleLeaveRoomImmediate, isAdminActive }) => {
    const splitRoomId = room?.room_id.split('-')[room?.room_id.split('-').length - 1]
    const roomName = room?.name ? room.name + "- " + splitRoomId : splitRoomId
    const countryCode = room?.location?.countryCode?.toLowerCase()
    const country = room?.location?.country
    const city = room?.location?.city
    const emailSendCheck = room?.is_admin_active
    const isClientActive = room?.is_client_active
    console.log(emailSendCheck, 'email Send ')
    return (
        <div className='h-[3.5rem] bg-white p-1 flex justify-between border-b-[0.5px] border-[#BCCCDC]'>
            <div>
                <h1 className='font-semibold text-lg '>{roomName}</h1>
                <div className='flex items-center gap-1'>
                    <ReactCountryFlag
                        countryCode={countryCode}
                        svg
                        style={{
                            width: "1.0em",
                            height: "1.0em",
                        }}
                    />
                    <p className='text-[0.67rem] text-gray-400'>{`${room?.location && (city + ", " + country)}`}</p>
                </div>
            </div>

            <div className='flex items-center gap-2'>

                {isClientActive && !isAdminActive ? (
                    <button
                        onClick={handleJoinRoom}
                        disabled={isAdminActive}
                        className="rounded-md px-4 py-1 bg-green-300 text-white text-base hover:bg-white hover:text-green-300 hover:border-2 hover:border-green-300"
                    >
                        Join
                    </button>
                ) : isAdminActive ? (
                    <button
                        onClick={handleLeaveRoomImmediate}
                        disabled={!isAdminActive}
                        className="rounded-md px-4 py-1 bg-red-500 text-white text-base hover:bg-white hover:text-red-500 hover:border-2 hover:border-red-500"
                    >
                        Leave
                    </button>
                ) : null}

                <BsThreeDotsVertical size={25} color='#BCCCDC' onClick={() => setToggleDetails(p => !p)} />
            </div>
        </div>
    )
}

const SelectSearch = (props) => {
    const { onSelectCountry, countries, className } = props
    return (
        <div className='country-select'>
            <Select
                className={`w-full h-11 ${className} drop-shadow-sm`}
                placeholder="Select Country"
                allowClear
                showSearch
                onChange={onSelectCountry}
            >
                {countries?.map((country, index) => (
                    <Option key={index} value={country}>
                        {country}
                    </Option>
                ))}
            </Select>
        </div>
    )
}


const ChatRooms = ({ rooms, onClickConversation, loadMore }) => {
    const observer = useRef();
    const pageLoader = useSelector(state => state?.utils?.pageLoader);
    const loading = pageLoader['getRooms'];
    const [isLoading, setIsLoading] = useState(false);
    // Observer to detect last room for infinite scroll
    const lastRoomRef = useCallback(
        (node) => {
            if (isLoading) return; // Don't trigger if already loading
            if (observer.current) observer.current.disconnect();

            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && !isLoading) {
                    loadMore();
                }
            });

            if (node) observer.current.observe(node);
        },
        [isLoading, loadMore] // Dependencies
    );



    return (
        <div className="chat-room-list h-full overflow-y-auto">
            <Spin spinning={loading}>
                {rooms.map((room, index) => (
                    <div
                        key={room.room_id}
                        ref={index === rooms.length - 1 ? lastRoomRef : null} // Attach ref to last room
                        className="grid grid-cols-5 w-full border-b-[1px] transition-all cursor-pointer"
                        onClick={() => onClickConversation(room.room_id)}
                    >
                        <div className="col-span-1 flex items-center justify-center">
                            <img src={require('../../../Assets/avatar.png')} alt="avatar" height={50} width={50} className="rounded-full" />
                        </div>
                        <div className="col-span-4 p-1">
                            <h3 className="font-bold text-[0.75rem]">
                                {room?.name ? room?.name : room?.room_id.split('-').pop()}
                                {room?.is_client_active === true && (
                                    <span className="w-2 h-2 rounded-full bg-green-500 inline-block gap-5 ml-1"></span>
                                )}

                                {room?.is_client_active === true && room?.is_admin_active === false && (
                                    <img
                                        src="/faviconsally.svg"
                                        alt="Active Indicator"
                                        className="w-3 h-3 rounded-full inline-block ml-1"
                                    />
                                )}

                            </h3>

                            <div className="flex items-center gap-2">
                                <ReactCountryFlag
                                    countryCode={room?.location?.countryCode?.toLowerCase()}
                                    svg
                                    style={{ width: "1.0em", height: "1.0em" }}
                                />
                                <p className="text-[0.67rem] text-gray-400 ">
                                    {room?.location ? `${room.location.city}, ${room.location.country}` : ""}
                                </p>
                             
                                <p className="text-[0.67rem] text-gray-400 ml-auto">
                                    {room?.updated_at ?
                                        (differenceInDays(new Date(), new Date(room?.updated_at)) >= 7
                                            ? new Date(room?.updated_at).toLocaleDateString()
                                            : formatDistanceToNow(new Date(room?.updated_at)).replace(/^about\s| ago$/, '') // Remove 'about' and 'ago'
                                        )
                                        : 'N/A'}
                                </p>


                            </div>

                        </div>

                    </div>

                ))}
            </Spin>


            {/* Loader (Spinner) */}

        </div>
    );
};




export const NoChatSelected = () => {
    return (
        <div className='flex flex-col flex-1 h-full items-center justify-center'>
            <svg width="150" height="150" viewBox="0 0 184 152" xmlns="http://www.w3.org/2000/svg"><title>No data</title><g fill="none" fill-rule="evenodd"><g transform="translate(24 31.67)"><ellipse fill-opacity=".8" fill="#F5F5F7" cx="67.797" cy="106.89" rx="67.797" ry="12.668"></ellipse><path d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z" fill="#AEB8C2"></path><path d="M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z" fill="url(#linearGradient-1)" transform="translate(13.56)"></path><path d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z" fill="#F5F5F7"></path><path d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z" fill="#DCE0E6"></path></g><path d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z" fill="#DCE0E6"></path><g transform="translate(149.65 15.383)" fill="#FFF"><ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815"></ellipse><path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"></path></g></g></svg>
            <p className='text-base font-semibold text-[#BCCCDC]'>No Conversation Selected</p>
        </div>
    )
}

export default Chat